import { Platform, StyleSheet } from 'react-native';
import config from '../../config';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...Platform.select({
      web: {
        backgroundColor: '#ffffff',
      },
      default: {
        backgroundColor: '#333333',
      },
    }),
  },
  containerSmall: {
    backgroundColor: '#333333',
    flex: 1,
    ...Platform.select({
      web: {
        alignSelf: 'auto',
        margin: 'auto',
      },
      default: {},
    }),
  },
  contentContainer: {
    marginStart: 15,
    ...Platform.select({
      android: {
        flex: 1,
      },
      ios: {
        flex: 1,
      },
    }),
  },
  noFlex: {
    flex: 0,
  },
  featuredItemsContainer: {
    minHeight: 275,
  },
  advertCategoryList: {
    minHeight: 120,
  },
  scrollView: {
    backgroundColor: '#ffffff',
    marginHorizontal: 0,
  },
  searchWrapper: { alignSelf: 'flex-start' },
  searchBarInput: {},
  searchBarInputContainer: {},
  searchBar: {},
  engine: {
    position: 'absolute',
    right: 0,
  },
  sectionContainer: {
    marginTop: 32,
    paddingHorizontal: 24,
  },
  featureHeadingContainer: {
    flex: 1,
    flexDirection: 'row',
    marginBottom: 5,
    justifyContent: 'space-between',
    marginHorizontal: 10,
  },
  sectionStart: {
    marginTop: 20,
    marginBottom: 10,
  },
  sectionEnd: {
    marginBottom: 10,
  },
  featureHeading: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  featureViewAll: {
    fontSize: 14,
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  scrollContainer: {
    flexGrow: 1,
    paddingBottom: config.theme.list.marginBottom,
  },
});

export default styles;
